<template>
  <form action="#" @submit.prevent="submit()">
    <div class="row">
      <div class="col-lg-7">
        <h3 class="h5 font-weight-bold mb-3">Žadatel</h3>

        <div class="form-group">
          <div class="mb-4 custom-placeholder">
            <input
              type="text"
              id="Name"
              class="form-control"
              v-model.trim="values.name"
              placeholder=" "
              required
            />
            <label class="label-floating" for="Name">
              <span> Jméno a příjmení </span>
            </label>
          </div>
        </div>

        <div class="form-group">
          <div class="mb-4 custom-placeholder">
            <input
              type="tel"
              id="Phone"
              class="form-control"
              v-model.trim="values.phone"
              placeholder=" "
              required
            />
            <label class="label-floating" for="Phone">
              <span> Kontaktní telefon </span>
            </label>
          </div>
        </div>

        <div class="form-group">
          <div class="mb-4 custom-placeholder">
            <input
              type="email"
              id="Email"
              class="form-control"
              v-model.trim="values.email"
              placeholder=" "
              required
            />
            <label class="label-floating" for="Email">
              <span> E-mail </span>
            </label>
          </div>
        </div>

        <div class="form-group">
          <div class="custom-control custom-checkbox">
            <input
              type="checkbox"
              class="custom-control-input"
              id="isEucEmployee"
              v-model="values.isEucEmployee"
            />
            <label class="custom-control-label" for="isEucEmployee">
              Jsem zaměstnanec EUC a.s.
            </label>
          </div>
        </div>

        <div class="form-group" v-show="values.isEucEmployee">
          <div class="mb-2 custom-placeholder">
            <input
              type="text"
              id="WorkPosition"
              class="form-control"
              v-model.trim="values.workPosition"
              placeholder=" "
            />
            <label class="label-floating" for="WorkPosition">
              <span> Název pracovní pozice </span>
            </label>
          </div>
          <div class="small mb-4">
            (dle zákona č.96/2004 sb. O nelékařských zdravotnických
            pracovnících)
          </div>
        </div>

        <h3 class="h5 font-weight-bold mb-3">Předmět žádosti</h3>

        <div class="form-group">
          <div class="mb-4 custom-placeholder">
            <input
              type="text"
              id="completeAmount"
              class="form-control"
              v-model.trim="values.completeAmount"
              placeholder=" "
              required
            />
            <label class="label-floating" for="completeAmount">
              <span> Potřebná částka celkem </span>
            </label>
          </div>
        </div>

        <div class="form-group">
          <div class="mb-4 custom-placeholder">
            <input
              type="text"
              id="requestedAmount"
              class="form-control"
              v-model.trim="values.requestedAmount"
              placeholder=" "
              required
            />
            <label class="label-floating" for="requestedAmount">
              <span>
                Částka požadovaná od Nadačního fondu EUC,,Elucidate“
              </span>
            </label>
          </div>
        </div>

        <div class="form-group mb-4">
          <div class="custom-file">
            <input
              type="file"
              class="custom-file-input"
              id="attachments"
              @change="handleFiles"
              multiple
            />
            <label
              class="custom-file-label text-truncate pr-5"
              for="attachments"
            >
              {{ attachmentsLabel }}
            </label>
          </div>
        </div>
      </div>

      <div
        class="col-lg-5 mb-4 pt-lg-4 mt-lg-2 text-primary order-first order-lg-0"
      >
        <p>
          Řádné vyplnění této žádosti jsou nezbytnými předpoklady, aby Nadační
          fond EUC „Elucidate“ mohl zvážit možnost uzavření smlouvy o poskytnutí
          nadačního příspěvku s žadatelem.
        </p>
      </div>

      <div class="col-12">
        <div class="form-group">
          <div class="mb-4 custom-placeholder">
            <textarea
              id="message"
              class="form-control"
              rows="4"
              v-model.trim="values.message"
              placeholder=" "
              required
            ></textarea>
            <label class="label-floating" for="message">
              <span> Předmět žádosti </span>
            </label>
          </div>
        </div>

        <div class="form-group">
          <div class="custom-control custom-checkbox">
            <input
              type="checkbox"
              class="custom-control-input"
              id="GdprAgreement"
              v-model="values.gdprAgreement"
              required
            />
            <label class="custom-control-label" for="GdprAgreement">
              Seznámil/a jsem se s
              <a href="/o-nas/ochrana-osobnich-udaju/" target="_blank"
                >Podmínkami ochrany osobních údajů.</a
              >
            </label>
          </div>
        </div>

        <div class="form-group">
          <div class="custom-control custom-checkbox">
            <input
              type="checkbox"
              class="custom-control-input"
              id="MarketingAgreement"
              v-model="values.marketingAgreement"
            />
            <label class="custom-control-label" for="MarketingAgreement">
              Souhlasím s využitím osobních údajů za účelem
              <a
                href="/files/souhlas-se-zpracovanim-ou-zpetna-vazba.pdf"
                target="_blank"
                >získání zpětné vazby</a
              >
              a se
              <a
                href="/files/souhlas-se-zpracovanim-ou-marketing.pdf"
                target="_blank"
                >zasíláním marketingových sdělení</a
              >.
            </label>
          </div>
        </div>

        <div class="form-group">
          <div class="custom-control custom-checkbox">
            <input
              type="checkbox"
              class="custom-control-input"
              id="truthfulStatement"
              v-model="values.truthfulStatement"
              required
            />
            <label class="custom-control-label" for="truthfulStatement">
              Prohlašuji, že všechny údaje v tomto dotazníku a v přílohách jsou
              pravdivé. Souhlasím tím, že Nadační fond EUC „Elucidate" si může
              ověřit na příslušném personálním oddělení mého zaměstnavatele
              skutečnosti o formě a rozsahu mého pracovního poměru.
            </label>
          </div>
        </div>
      </div>

      <div class="col-12">
        <div class="alert alert-secondary mb-4" v-if="error.showing">
          {{
            error.text
              ? error.text
              : 'Něco se nezdařilo, zkuste to prosím později'
          }}
        </div>

        <div class="form-group text-right">
          <button type="submit" class="btn btn-secondary" :disabled="isSending">
            {{ buttonText }}
          </button>
        </div>

        <div class="mt-3 text-gray-lighter font-size-small">
          <p>
            Tato stránka je chráněna systémem reCAPTCHA od Google s
            <a
              href="https://policies.google.com/privacy"
              target="_blank"
              class="text-gray-lighter"
            >
              <u>ochranou soukromí</u>
            </a>
            a
            <a
              href="https://policies.google.com/terms"
              target="_blank"
              class="text-gray-lighter"
            >
              <u>podmínkami používání</u> </a
            >.
          </p>
        </div>
      </div>
    </div>
  </form>
</template>

<script>
import { load as recaptchaLoad } from 'recaptcha-v3'
import axios from 'axios'

export default {
  data () {
    return {
      error: {
        showing: false,
        text: ''
      },
      isSending: false,
      values: {
        name: '',
        phone: '',
        email: '',

        isEucEmployee: false,
        workPosition: '',
        completeAmount: '',
        requestedAmount: '',
        message: '',

        gdprAgreement: false,
        marketingAgreement: false,
        truthfulStatement: false,

        attachments: null
      }
    }
  },
  methods: {
    async submit () {
      this.isSending = true
      this.error.showing = false
      this.error.text = ''

      const formData = new FormData()

      for (const value in this.values) {
        if (value === 'attachments') {
          continue
        }

        formData.append(value, this.values[value])
      }

      if (this.values.attachments) {
        Array.from(this.values.attachments).forEach(file => {
          formData.append('attachments', file)
        })
      }

      // handle reCaptcha
      let reCaptchaResponse = ''

      // if we have site key
      const siteKey = $.getRecaptchaSiteKey()
      if (siteKey.length) {
        // await captcha load
        const recaptcha = await recaptchaLoad(siteKey)

        // get token
        reCaptchaResponse = await recaptcha.execute('nadace_person_form')
      }

      // add reCaptcha token to data
      formData.append('reCaptchaResponse', reCaptchaResponse)

      axios
        .post('/umbraco/api/ApplicationForm/PostIndividualForm', formData, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        })
        .then(() => {
          this.$emit('done')
        })
        .catch(error => {
          if (error.response.data.message) {
            this.error.text = error.response.data.message
          }

          this.error.showing = true
        })
        .finally(() => {
          this.isSending = false
        })
    },
    handleFiles (event) {
      this.values.attachments = event.target.files
    }
  },
  watch: {
    'values.isEucEmployee': function () {
      this.values.workPosition = ''
    }
  },
  computed: {
    buttonText () {
      if (this.isSending) {
        return 'Odesílám...'
      } else {
        return 'Odeslat žádost'
      }
    },
    attachmentsLabel () {
      if (!this.values.attachments) {
        return 'Přílohy'
      }

      return Array.from(this.values.attachments)
        .map(file => file.name)
        .join(', ')
    }
  }
}
</script>
